<template>
  <div class="photography-casting-content" id="identidade-visual-fotografia-escolha-de-casting" data-search-anchor>
    <div class="title-photography-casting-wrapper">
      <h1 class="photography-casting-title-span">{{ photographyCastingTitleSpan }}</h1>
      <h1 class="photography-casting-title">{{ photographyCastingTitle }}</h1>
    </div>
    <div class="description-photography-casting-wrapper">
      <p class="photography-casting-description">{{ photographyCastingDescription }}</p>

      <div>
        <p class="fica-a-dica">
          {{ photographyCastingDescription1 }}
        </p>

        <div>
          <p class="photography-casting-description">
            {{ photographyCastingDescription2 }}
          </p>
        </div>        

        <div>
          <p class="photography-casting-description">
            {{ photographyCastingDescription4 }}
          </p>
        </div>
      </div>
    </div>
    <div class="expandable-image-casting">
      <PhotographyExpandableImage :src="photographyCastingImageSrc1" alt="" />
      <PhotographyExpandableImage :src="photographyCastingImageSrc2" alt="" />
      <PhotographyExpandableImage :src="photographyCastingImageSrc3" alt="" />
      <PhotographyExpandableImage :src="photographyCastingImageSrc4" alt="" />
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PhotographyPageMixin from '@/mixins/photography-page-mixin'
import { PhotographyPageStore } from '@/store/visual-identity-page/photography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PhotographyExpandableImage from './PhotographyExpandableImage.vue'

@Component({
  components: { PhotographyExpandableImage }
})
export default class PhotographyCastingSection extends Mixins(PhotographyPageMixin) {
  photographyPageStore: PageStoreContract = getModule(PhotographyPageStore, this.$store)

  get photographyCastingTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get photographyCastingTitle(): string {
    return this.getElementText(2, 0)
  }

  get photographyCastingDescription(): string {
    return this.getElementText(2, 1)
  }

  get photographyCastingDescription1(): string {
    return this.getElementText(2, 2)
  }

  get photographyCastingDescription2(): string {
    return this.getElementText(2, 3)
  }

  get photographyCastingDescription4(): string {
    return this.getElementText(2, 4)
  }

  get photographyCastingImageSrc1(): string {
    return this.getElementMedia(2, 5)
  }

  get photographyCastingImageSrc2(): string {
    return this.getElementMedia(2, 6)
  }

  get photographyCastingImageSrc3(): string {
    return this.getElementMedia(2, 7)
  }

  get photographyCastingImageSrc4(): string {
    return this.getElementMedia(2, 8)
  }

  async getPhotographyPage(): Promise<void> {
    await this.photographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.photographyPageStore.isLoading) {
      await this.getPhotographyPage()
    }
  }
}
</script>

<style lang="scss">
.photography-casting-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-photography-casting-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.photography-casting-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.photography-casting-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-photography-casting-wrapper {
  align-items: baseline; 
  position: relative;  

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;  
}

.photography-casting-description,
.fica-a-dica {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;
  margin-top: 0;
  white-space: pre-line;  
}

.expandable-image-casting {
  display: grid;
  grid-template-columns: 1fr 1fr;  
  gap: 15px;    
}
</style>
